module.exports = __webpack_public_path__ + "img/logo.424d1d0f.svg";